import React from 'react';
import Tags from "../Information/Tags";
import ButtonActions from "../Actions/ButtonActions";
import SpaceBetween from "../Layouts/SpaceBetween";

type ListItemProps = {
    label: string,
    tags: string[],
    actions: React.ReactNode,
    containerKey?: string
}

function ListItem(props: ListItemProps) {
    const {label, actions, tags, containerKey} = props
    return (
        <div className={"molekuls-three-listitem"} key={containerKey ? containerKey : ""}>
            <h4 className="item-name">{label}</h4>
            <SpaceBetween>
                <Tags tags={tags}/>
                <ButtonActions>
                    {actions}
                </ButtonActions>
            </SpaceBetween>
        </div>
    );
}

export default ListItem;
